var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isDetailChat)?_c('div',{staticClass:"pop-chat-index"},[_c('ListChat',{on:{"showDetail":_vm.showDetail}})],1):_c('div',{staticStyle:{"height":"600px"}},[_c('DetailChat',{attrs:{"infoDetail":_vm.infoDetail,"dataRight":_vm.dataRight},on:{"backListChat":_vm.backListChat}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }